import { Tooltip } from "@chakra-ui/react";
import { FcInfo } from "react-icons/fc";
const StyledToolTip = ({ background, color, iconColor, content }) => {
	return (
		<Tooltip
			closeOnMouseDown={true}
			colorScheme="blue"
			borderRadius="15px"
			shouldWrapChildren
			style={{
				background: background,
				padding: "6px 12px",
				color: color,
			}}
			label={content}
			placement="right"
		>
			<FcInfo
				size="1rem"
				style={{
					display: "inline",
					marginInlineStart: ".4rem",
					cursor: "pointer",
				}}
			/>
		</Tooltip>
	);
};
export default StyledToolTip;